(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-products3"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* 只负责交换背景图 */
  function swapBg(wrapper, imgNode) {
    const mobUrl = wrapper.dataset.mob;
    if (!mobUrl) return;
    if (window.innerWidth < 768) {
        imgNode.style.backgroundImage = `url(${mobUrl})`;
        console.log("innerWidth < 768", `url(${mobUrl})`);
    } else {
        imgNode.style.backgroundImage = `url(${wrapper.dataset.desk})`;
        console.log("innerWidth > 768", `url(${wrapper.dataset.desk})`);
    }
  }

  /* 等两个节点都出现 → 绑定 → 停止轮询 */
  function waitAndInit() {
    const wrapper = document.querySelector('.banner-with-product3-bgimg-wrapper');
    const imgNode = document.querySelector('.banner-with-product3-bgimg');

    if (!wrapper || !imgNode) {          // 还没出现 → 继续等
      return false;
    }
    // 真正开始干活
    swapBg(wrapper, imgNode);            // 先切一次
    window.addEventListener('resize', () => swapBg(wrapper, imgNode));
    return true;                         // 告诉轮询可以停了
  }

  /* 轮询：每 300ms 检查一次，最多 30 次（约 9s），基本够用 */
  let left = 30;
  const timer = setInterval(() => {
    if (waitAndInit() || --left <= 0) {
      clearInterval(timer);
    }
  }, 300);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
window.requestAnimationFrame(function () {
    getMbLayout();
  })
   $(window).on("load",function(){
getMbLayout("good");
 })
 document.addEventListener("DOMContentLoaded", function () {
  // 等待 DOM 渲染完成后进行检测
  waitForSlidersAndInit();
});

function waitForSlidersAndInit(retries = 60) {
  const $sliders_ = $('.slider-full');
  
  if ($sliders_.length > 1 || retries <= 0) {
    // 足够数量的 slider 出现 或 重试次数用完就执行
    getMbLayout();
  } else {
    // 等 100ms 再试一次，最多重试 10 次（1 秒）
    setTimeout(() => waitForSlidersAndInit(retries - 1), 100);
  }
}



  function getMbLayout(status){
   
     const $sliders = $('.slider-full.mb-layout-grid');
    console.log($sliders, "sliders");

    if (window.innerWidth <= 767) {
      if ($sliders.length > 0) {
        $sliders.each(function () {
          const $slider = $(this);
          const count = parseInt($slider.attr('data-count')) - 1;
          const after = parseInt($slider.attr('data-after')) + count;

          // 销毁 Flickity 实例  
    $slider.removeClass('flickityt4s');
          $slider.removeAttr('data-flickityt4s-js');
 
          const $loadMore = $slider.parent().find('.load-more');
          const $items = $slider.find('.t4s-product');

          $items.each(function (i) {
            if (i > count) {
              $(this).hide();
            }
          });

          $loadMore.on('click', function () {
            $loadMore.hide();
            $items.each(function (i) {
              if (i > count && i <= after) {
                $(this).show();
              }
            });
          });
        });
      }
    }
    if(status=="good"){
     $(".custom-list").addClass("already");
    }
}
 

  } catch(e) { console.error(e); }
})();
})();
